export default __webpack_public_path__ + "static/media/telegram.0e24abcd.png";